import React, { Component } from 'react'
import I18n from "i18n-js";
export default class SelectType extends Component {
  constructor(props) {
    super(props);
    this.dailyPrice = this.dailyPrice.bind(this);
    this.showPrice = this.showPrice.bind(this);
    this.isDisabled = this.isDisabled.bind(this);
    this.isSoldOut = this.isSoldOut.bind(this);
  }

  isDisabled(id, type) {
    if (type === 'show' && this.props.tab['id'] == 'stalls') {
      var stall = this.props.stallsAvailable.find(item => item.id == id)

      return stall["avbl_show_units"] == 0
    } else if (type === 'day' && this.props.tab['id'] == 'stalls'){
      var stall = this.props.stallsAvailable.find(item => item.id == id)
      stall['avbl_daily_units'].every(day => day['value'] == 0)

      return stall['avbl_daily_units'].every(day => day['value'] == 0)
    }

    if (type === 'show' && this.props.tab['id'] == 'campsites') {
      var campsite = this.props.campsitesAvailable.find(item => item.id == id)

      return campsite["avbl_show_units"] == 0
    } else if (type === 'day' && this.props.tab['id'] == 'campsites'){
      var campsite = this.props.campsitesAvailable.find(item => item.id == id)
      campsite['avbl_daily_units'].every(day => day['value'] == 0)

      return campsite['avbl_daily_units'].every(day => day['value'] == 0)
    }
  }

  displayInFrench(category){
    if(category=="Daily") {
      if(I18n.locale=="fr")
        return "Journalier"
      else
        return "Daily"
    }
    if(category=="Show") {
      if(I18n.locale=="fr")
        return "Spectacle"
      else
        return "Show"
    }
  }

  isSoldOut(id, type) {
    return this.isDisabled(id, type) ? 'Sold Out' : ''
  }

  priceOption(id, name, price, type) {
    if (price && price > 0) {//Number(price).toFixed(2)
      return <option key={id} value={id} disabled={this.isDisabled(id, type) ? true : null}>{`${name} @ <${I18n.toCurrency(price)}/${type}> ${this.isSoldOut(id, type)}`}</option>;
    }
  }

  dailyPrice(service) {
    return this.priceOption(service.id, service.name, service.daily_cost, I18n.t("season_stalls.day"));
  }

  showPrice(service) {
    return this.priceOption(service.id, service.name, service.show_cost, I18n.t("wizard.show"));
  }

  render() {
    return (
      <div>
        <h4>{`${this.props.tab.name} (${this.displayInFrench(this.props.category)})`}</h4>
        <div className="control-group select optional">
          <label className="select optional control-label">{`${this.props.tab.name.slice(0,-1)} Type`}</label>
          <select name={`${this.props.category}Type`} id={`${this.props.tab.id}${this.props.category}Type`} disabled={this.props.disabledSelect} value={this.props.value} onChange={this.props.onChange}>
            <option value=""></option>
            {this.props.category == "Daily"  ?
              this.props.serviceTypes.map(this.dailyPrice) :
              this.props.serviceTypes.map(this.showPrice)
            }
          </select>
        </div>
      </div>
    )
  }
}

